import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useSubscription } from '../../hooks/useSubscription';
import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';
import { getTrackingQuery } from '../../lib/utils';

import { useSubscriptions } from '../../contexts/SiteContext';
import SubscriptionForm from '../forms/SubscriptionForm';
import Summary from './Summary';

import styles from '../../styles/summaries/author-summary.module.css';

export interface AuthorSummaryProps {
    id?: string | null;
    slug?: string | null;
    clickRef?: string | null;
    name?: string | null;
    description?: string | null;
    shortDescription?: string | null;
    subscriptionSource?: string | null;
    withButton?: boolean;
    withSubscribeButton?: boolean;
    className?: string | null;
    imageClassName?: string | null;
    pictureClassName?: string | null;
    [key: string]: unknown;
}

function AuthorSummary({
    id = null,
    slug = null,
    clickRef = null,
    name = null,
    description = null,
    shortDescription = null,
    subscriptionSource = null,
    withButton = false,
    withSubscribeButton = false,
    className = null,
    imageClassName = null,
    pictureClassName = null,
    ...props
}: AuthorSummaryProps) {
    const url = useAuthorUrlGenerator();
    const subscriptions = useSubscriptions();
    const subscription =
        subscriptions.find(({ author = null }) => author !== null && author.id === id) || null;
    const { subscribed = false, unsubscribe } = useSubscription({
        subscription: subscription !== null ? subscription.handle : null,
    });
    return (
        <Summary
            {...props}
            link={url(
                {
                    slug,
                },
                getTrackingQuery({
                    clickRef: clickRef || 'summary',
                }),
            )}
            title={name}
            description={shortDescription || description}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            imageClassName={classNames([
                styles.image,
                {
                    [imageClassName]: imageClassName !== null,
                },
            ])}
            pictureClassName={classNames([
                styles.picture,
                {
                    [pictureClassName]: pictureClassName !== null,
                },
            ])}
            buttonLabel={<FormattedMessage defaultMessage="Voir plus" description="Button label" />}
            withButton={withButton && !withSubscribeButton}
            withLink={withSubscribeButton && subscribed}
        >
            {subscription !== null && subscribed !== null && !subscribed && withSubscribeButton ? (
                <div className={styles.subscription}>
                    <SubscriptionForm
                        subscription={subscription.handle}
                        source={subscriptionSource}
                        buttonOnly
                        compact
                        withoutSso
                        className={styles.form}
                    />
                </div>
            ) : null}
        </Summary>
    );
}

export default AuthorSummary;
